import React from "react";
import { createRoot } from "react-dom/client";
import { ReactWrapper } from "./ReactWrapper";
import { generateUniqueID } from "./uniqueId";
import { Events } from "./constants";
// TODO - point this to mc npm package
import { VideoEvents } from "../../components/src/video/globals";

export class OrcaApi {
  constructor() {
    this.render = (node, settings, uniqueId = null) => {
      const orcaId = uniqueId ?? generateUniqueID();
      node["uniqueId"] = orcaId;
      window.orcas[orcaId] = settings;
      const attachDomNode = ({ node: videoElement, orcaPlayer }) => {
        node["orcaPlayer"] = orcaPlayer;
        window.orcas[orcaId].orcaPlayer = orcaPlayer;
        window.orcas[orcaId].videoElement = videoElement;
      };
      const root = createRoot(node);
      root.render(
        <ReactWrapper
          settings={settings}
          uniqueId={orcaId}
          attachDomNode={attachDomNode}
        />
      );
    };

    this.update = (node, settings) => {
      const uniqueId = node.uniqueId;
      window.orcas[uniqueId] = settings;
      const event = new CustomEvent(Events.PROPS_UPDATED, {
        detail: {
          id: uniqueId,
          props: settings
        }
      });
      window.dispatchEvent(event);
    };

    this.events = Object.values(VideoEvents);
  }
}
